export const LIST_BRANCH_PRACTITIONER_REQUEST = 'LIST_BRANCH_PRACTITIONER_REQUEST'
export const LIST_BRANCH_PRACTITIONER_SUCCESS = 'LIST_BRANCH_PRACTITIONER_SUCCESS'
export const LIST_BRANCH_PRACTITIONER_FAIL = 'LIST_BRANCH_PRACTITIONER_FAIL'

export const UPDATE_BRANCH_PRACTITIONER_REQUEST = 'UPDATE_BRANCH_PRACTITIONER_REQUEST'
export const UPDATE_BRANCH_PRACTITIONER_SUCCESS = 'UPDATE_BRANCH_PRACTITIONER_SUCCESS'
export const UPDATE_BRANCH_PRACTITIONER_FAIL = 'UPDATE_BRANCH_PRACTITIONER_FAIL'

export const CREATE_BRANCH_PRACTITIONER_REQUEST = 'CREATE_BRANCH_PRACTITIONER_REQUEST'
export const CREATE_BRANCH_PRACTITIONER_SUCCESS = 'CREATE_BRANCH_PRACTITIONER_SUCCESS'
export const CREATE_BRANCH_PRACTITIONER_FAIL = 'CREATE_BRANCH_PRACTITIONER_FAIL'

export const DELETE_BRANCH_PRACTITIONER_REQUEST = 'DELETE_BRANCH_PRACTITIONER_REQUEST'
export const DELETE_BRANCH_PRACTITIONER_SUCCESS = 'DELETE_BRANCH_PRACTITIONER_SUCCESS'
export const DELETE_BRANCH_PRACTITIONER_FAIL = 'DELETE_BRANCH_PRACTITIONER_FAIL'

export const DETAIL_BRANCH_PRACTITIONER_REQUEST = 'DETAIL_BRANCH_PRACTITIONER_REQUEST'
export const DETAIL_BRANCH_PRACTITIONER_SUCCESS = 'DETAIL_BRANCH_PRACTITIONER_SUCCESS'
export const DETAIL_BRANCH_PRACTITIONER_FAIL = 'DETAIL_BRANCH_PRACTITIONER_FAIL'

export const LIST_BRANCH_PRACTITIONER_SCHEDULE_REQUEST = 'LIST_BRANCH_PRACTITIONER_SCHEDULE_REQUEST'
export const LIST_BRANCH_PRACTITIONER_SCHEDULE_SUCCESS = 'LIST_BRANCH_PRACTITIONER_SCHEDULE_SUCCESS'
export const LIST_BRANCH_PRACTITIONER_SCHEDULE_FAIL = 'LIST_BRANCH_PRACTITIONER_SCHEDULE_FAIL'

export const DETAIL_BRANCH_PRACTITIONER_SCHEDULE_REQUEST = 'DETAIL_BRANCH_PRACTITIONER_SCHEDULE_REQUEST'
export const DETAIL_BRANCH_PRACTITIONER_SCHEDULE_SUCCESS = 'DETAIL_BRANCH_PRACTITIONER_SCHEDULE_SUCCESS'
export const DETAIL_BRANCH_PRACTITIONER_SCHEDULE_FAIL = 'DETAIL_BRANCH_PRACTITIONER_SCHEDULE_FAIL'